<h2 mat-dialog-title *ngIf="data.title">{{ data.title }}</h2>
<mat-dialog-content *ngIf="data.message"
  ><p [innerHTML]="data.message"></p
></mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="false">
    {{ data.cancel || "Não" }}
  </button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>
    {{ data.ok || "Sim" }}
  </button>
</mat-dialog-actions>
